import React from 'react'
import Switch from 'react-switch'


const DeveloperApi = () => (
  <div>
    <div className="uk-inline">
      <h3 className="uk-inline">
        Developer API
        <a
          className="uk-text-middle uk-margin-small-left"
          data-uk-icon="icon: question; ratio: 0.8"
          href="https://developers.hackedu.com"
          rel="noopener noreferrer"
          target="_blank"
        />
      </h3>
    </div>
    <div
      className="uk-card uk-card-default uk-card-body"
      style={{
        maxWidth: 750,
      }}
    >

      <div>
        <div className="uk-margin">
          <div className="uk-inline">
            <Switch
              checked={false}
              disabled
              id="normal-switch"
              offColor="#999999"
              onColor="#1e87f0"
              checkedIcon={false}
              uncheckedIcon={false}
            />
              <span className="uk-margin-small-left uk-text-top">
                Enable API
              </span>
          </div>

          <p>
            Please contact
            &nbsp;
            <a href="mailto:support@hackedu.com">support@hackedu.com</a>
            &nbsp;
            to request your API Key.
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default DeveloperApi
